function r(n) {
  return function(e) {
    return n == null ? void 0 : n[e];
  };
}
export {
  r as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_basePropertyOf.js
// module id = 1445
// module chunks = 41